import React, { useContext } from "react";
import {
    Box,
    Grid,
    Stack,
    TextField,
    IconButton,
    Typography,
} from "@mui/material";
import "../../../Style/dialogstyle.scss";
import { AuthContext } from "../../../Context/AuthContext";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { SelectIncomeHeads } from "../../Include/DynamicSelect";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

export default function TabsAdminFee({ listPaymentData, setListPaymentData, required, }) {
    // Change Language
    const { language } = useContext(AuthContext);

    const paymentItem = {
        discount: 0,
        countMonth: 1,
        endDate: null,
        startDate: null,
        incomeHead: null,
        unit: null,
        key: Date.now() + Math.random(),
    }

    const handeAddItem = () => setListPaymentData([...listPaymentData, paymentItem]);

    const handeRemoveItem = (key) => {
        const data = listPaymentData.filter(e => e.key !== key);
        setListPaymentData(data);
    }

    const handeChangeValue = (key, fieldName, value) => {
        console.log("select income head key::", key)
        console.log("select income head fieldName::", fieldName)
        console.log("select income head value::", value)
        const data = listPaymentData.map((e) => {
            console.log("listPaymentData e::", e)
            if (e.key === key && fieldName === "endDate") e.endDate = value;
            if (e.key === key && fieldName === "startDate") e.startDate = value;
            if (e.key === key && fieldName === "incomeHead") e.incomeHead = value;
            if (e.key === key && fieldName === "unit") e.unit = value;
            if (e.key === key && fieldName === "discount") e.discount = parseFloat(value || 0);
            if (e.key === key && fieldName === "countMonth") e.countMonth = parseFloat(value || 0);
            console.log("listPaymentData e after condi::", e)
            return e;
        });
        setListPaymentData(data);
    }

    return (
        <Stack direction="column" spacing={1} >
            <Stack direction="row" alignItems="center" justifyContent="space-between" >
                <Typography className="field-title" sx={{ fontWeight: "bold", fontSize: "16px !important" }}>Add</Typography>
                <IconButton sx={{ marginRight: 1.5 }} onClick={handeAddItem}>
                    <AddBoxOutlinedIcon sx={{ color: "green" }} />
                </IconButton>
            </Stack>

            <Stack direction="column" spacing={2} minHeight={320}>
                {listPaymentData?.map((e, index) => (
                    <Stack
                        key={index}
                        direction="column"
                        sx={{
                            borderRadius: 2,
                            boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px"
                        }}
                    >

                        <Grid
                            container
                            rowSpacing={1}
                            columnSpacing={2}
                            sx={{ padding: 2.2, paddingRight: 1.5, paddingTop: 1.2 }}
                        >

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{
                                marginBottom: -2.5,
                                marginTop: -0.5

                            }}>
                                <Stack direction="row" alignItems="center" justifyContent="flex-end">
                                    <Box>
                                        <IconButton onClick={() => handeRemoveItem(e?.key)}>
                                            <CloseOutlinedIcon sx={{ color: "red" }} />
                                        </IconButton>
                                    </Box>
                                </Stack>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                <Typography className="field-title">Income Head</Typography>
                                <SelectIncomeHeads
                                    required={required}
                                    selectedVal={e?.incomeHead}
                                    setSelectedVal={(value) => handeChangeValue(e.key, "incomeHead", value)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                <Typography className="field-title">Count Month</Typography>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type="number"
                                    placeholder="0"
                                    className="text-field"
                                    value={e?.countMonth || 0}
                                    error={required && !e?.countMonth}
                                    onChange={({ target }) => handeChangeValue(e.key, "countMonth", target.value)}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                <Typography className="field-title">
                                    Additional Fee
                                </Typography>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type="number"
                                    placeholder="0"
                                    disabled={true}
                                    className="text-field"
                                    value={(e?.incomeHead?.price * e?.countMonth) || 0}
                                    InputProps={{ inputProps: { min: 0, }, endAdornment: "$", }}
                                    onChange={({ target }) => handeChangeValue(e.key, "amount", Math.max(target.value, 0))}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                <Typography className="field-title">
                                    Start Date
                                </Typography>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        value={e?.startDate}
                                        className="search-field"
                                        onChange={(newValue) => handeChangeValue(e.key, "startDate", newValue)}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                size="small"
                                                fullWidth
                                            // error={required && !e?.startDate} 
                                            />}
                                    />
                                </LocalizationProvider>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                <Typography className="field-title">
                                    End Date
                                </Typography>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        value={e?.endDate}
                                        className="search-field"
                                        onChange={(newValue) => handeChangeValue(e.key, "endDate", newValue)}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                size="small"
                                                fullWidth
                                            // error={required && !e?.endDate}
                                            />}
                                    />
                                </LocalizationProvider>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                                <Typography className="field-title">Dicount</Typography>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type="number"
                                    placeholder="0"
                                    value={e?.discount || 0}
                                    className="text-field"
                                    InputProps={{ inputProps: { min: 0, }, endAdornment: "$", }}
                                    onChange={({ target }) => handeChangeValue(e.key, "discount", Math.max(target.value, 0))}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Typography className="field-title">Total</Typography>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type="number"
                                    disabled={true}
                                    placeholder="0"
                                    className="text-field"
                                    InputProps={{ inputProps: { min: 0, }, endAdornment: "$", }}
                                    value={(e?.incomeHead?.price * e?.countMonth - e?.discount) || 0}
                                    onChange={({ target }) => handeChangeValue(e.key, "amount", Math.max(target.value, 0))}
                                />
                            </Grid>

                        </Grid>

                    </Stack>
                ))}
            </Stack>
        </Stack>
    );
}
